import { render, staticRenderFns } from "./reset-password-send-otp.vue?vue&type=template&id=18d8dee7&scoped=true&"
import script from "./reset-password-send-otp.vue?vue&type=script&lang=js&"
export * from "./reset-password-send-otp.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-send-otp.vue?vue&type=style&index=0&id=18d8dee7&lang=scss&scoped=true&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=18d8dee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8dee7",
  null
  
)

component.options.__file = "reset-password-send-otp.vue"
export default component.exports